/** Must match PDF layout: cover + post table on page 0, then full table pages. */
export const REPORT_PDF_FIRST_PAGE_POSTS_FULL = 7;
/** When the PDF cover includes a report date strip, leave vertical room — one fewer post on page 0. */
export const REPORT_PDF_FIRST_PAGE_POSTS_COMPACT = 6;
export const REPORT_PDF_OTHER_PAGE_POSTS = 10;
export const REPORT_PDF_MAX_POSTS = 1000;

export type ReportPdfPaginationOptions = {
  /** True when the PDF cover includes a report date strip (fewer posts on page 0). */
  compactFirstPage?: boolean;
};

function firstPagePostCount(options?: ReportPdfPaginationOptions): number {
  return options?.compactFirstPage
    ? REPORT_PDF_FIRST_PAGE_POSTS_COMPACT
    : REPORT_PDF_FIRST_PAGE_POSTS_FULL;
}

export function calculateReportPdfPageCount(
  totalItems: number,
  options?: ReportPdfPaginationOptions,
): number {
  if (totalItems <= 0) {
    return 0;
  }
  const first = firstPagePostCount(options);
  const capped = Math.min(totalItems, REPORT_PDF_MAX_POSTS);
  const afterFirst = capped - first;
  if (afterFirst <= 0) {
    return 1;
  }
  return 1 + Math.ceil(afterFirst / REPORT_PDF_OTHER_PAGE_POSTS);
}

/** Inclusive start, exclusive end — pass to `posts.slice(start, end)`. */
export function getReportPdfPostSlice(
  pageIndex: number,
  options?: ReportPdfPaginationOptions,
): [number, number] {
  const first = firstPagePostCount(options);
  const p =
    Number.isFinite(pageIndex) && pageIndex >= 0 ? Math.floor(pageIndex) : 0;
  if (p === 0) {
    return [0, first];
  }
  const start = first + (p - 1) * REPORT_PDF_OTHER_PAGE_POSTS;
  const end = start + REPORT_PDF_OTHER_PAGE_POSTS;
  return [start, end];
}
